export default "__VITE_ASSET__43530b29__"